import ActionOutcome from '@eversports/react-components/patterns/ActionOutcome'
import FormatDate from '@eversports/react-components/primitives/FormatDate'
import Heading from '@eversports/react-components/primitives/Heading'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { Localized } from '../localization/react'

interface Props {
  usedAt?: string | null
  usedForCompanyName?: string | null
}

const InvalidURL: React.FC<React.PropsWithChildren<Props>> = ({ usedAt, usedForCompanyName }) => (
  <ActionOutcome type="error" justifyContent="center" flexGrow={1}>
    <Heading data-testid="not-found" is="h1">
      <Localized id="invalid-url-heading" />
    </Heading>
    <Text>
      <Localized id="invalid-url-subheading" />
    </Text>
    {usedAt && usedForCompanyName && (
      <Text data-testid="invalid-url-used-detail">
        <Localized
          id="invalid-url-used-detail"
          params={{
            date: <FormatDate variant="medium" value={new Date(usedAt)} />,
            company: <strong>{usedForCompanyName}</strong>,
          }}
        />
      </Text>
    )}
  </ActionOutcome>
)

export default InvalidURL
